import React, { FC, ReactNode } from 'react';
import LinkifyIt from 'linkify-it';

import { isReactPath } from 'src/common/utils/routing';
import getClassName from 'src/common/utils/getClassName';
import UniversalLink from '../../../common/components/UniversalLink';
import s from './MessageContent.module.scss';

const addLinks = (contents: string) => {
  const linkify = new LinkifyIt();

  const matches = linkify.match(contents);
  if (!matches) {
    return contents;
  }

  const elements: ReactNode[] = [];
  let lastIndex = 0;
  matches.forEach(match => {
    if (match.index > lastIndex) {
      elements.push(contents.substring(lastIndex, match.index));
    }

    const parsedUrl = new URL(match.url);
    const isFromZendesk = parsedUrl.origin.includes('zendesk');
    const isExternal = isFromZendesk || !isReactPath(parsedUrl.pathname);

    elements.push(
      <UniversalLink
        key={match.index}
        to={isExternal ? match.url : parsedUrl.pathname}
        openInNewTab={isExternal}
      >{match.text}
      </UniversalLink>,
    );

    lastIndex = match.lastIndex;
  });

  if (contents.length > lastIndex) {
    elements.push(contents.substring(lastIndex));
  }

  return elements;
};

type MessageContentProps = {
  children: string;
  ownModifier?: string;
  time?: string;
  dateTimeString?: string;
};

const MessageContent: FC<MessageContentProps> = ({
  ownModifier,
  children = '',
  time,
  dateTimeString,
}) => (
  <div
    data-test="message-content"
    className={getClassName(s, 'root', ownModifier)}
  >
    {addLinks(children)}
    <time
      className={s.time}
      dateTime={dateTimeString}
    >
      {time}
    </time>
  </div>
);

export default MessageContent;
